export default __webpack_public_path__ + "static/media/parthner-diagnolita.797733c3.png";